<template>
  <component
    :class="[type, {'heading-with-icon' : icon}, {'heading-with-image' : image}]"
    :is="kind"
  >
    <span
      v-if="icon"
      :class="`icon icon-${icon}`"
    />
    <img
      v-if="image"
      :src="image"
    >
    <template v-if="$slots.default">
      <slot />
    </template>
  </component>
</template>

<script>
export default {
  name: 'Heading',
  props: {
    kind: {
      default: 'h1',
      validator(value) {
        return ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].indexOf(value) !== -1;
      },
    },
    type: {
      validator(value) {
        return ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].indexOf(value) !== -1;
      },
    },
    icon: String,
    image: String,
  },
};
</script>

<style lang="scss" scoped>
  h1, h2, h3, h4, h5, h6,
  .h1, .h2, .h3, .h4, .h5, .h6 {
    line-height: 1.3;
    span {
      font-weight: 400;
    }
  }

  h1, .h1 {
    font-size: rem(32);
    color: $--color-text-regular;
    strong {
      font-weight: 400;
    }
  }

  h2, .h2 {
    font-size: rem(22);
    margin-top: rem(20);
    margin-bottom: rem(20);
    color: $--color-text-regular;

    .new-form-enabled & {
      margin-top: inherit;
      margin-bottom: rem(40);
    }
  }

  h3, .h3 {
    margin-top: rem(30);
    margin-bottom: rem(20);
    font-size: rem(16);
    color: $--color-text-regular;
  }

  h4, .h4 {
    font-size: rem(18);
    line-height: 160%;
  }

  h5, .h5 {
    margin-top: rem(30);
    margin-bottom: rem(20);
    font-size: rem(14);
    color: $--color-text-regular;
  }

  .heading-with-icon {
    position: relative;
    padding-left: em(34);
    text-transform: uppercase;

    .icon {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      font-size: em(24);
      color: $--color-primary;
    }
  }

  .heading-with-image {
    position: relative;
    padding-left: em(34);

    img {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: em(24);
      height: auto;

      @include res(xs-only, $--breakpoints-spec) {
        width: em(18);
      }
    }
  }

  .heading--semibold {
    font-weight: 600;
  }

  .heading--highlighted {
    color: $--color-primary;
  }

  .heading--secondary-color {
    color: $--color-text-blue;
  }
</style>
